import React from 'react';
import { Box, Container, Typography, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const TermsPage = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 4 }}>
          <Link component={RouterLink} to="/" underline="hover" color="inherit">
            Inicio
          </Link>
          <Typography color="text.primary">Términos y Condiciones</Typography>
        </Breadcrumbs>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
            Términos y Condiciones
          </Typography>

          <Typography variant="body1" paragraph>
            Última actualización: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            1. Aceptación de términos
          </Typography>
          <Typography variant="body1" paragraph>
            Al acceder o utilizar la plataforma MekaSys, usted acepta estar sujeto a estos Términos y Condiciones de uso. Si no está de acuerdo con alguno de estos términos, está prohibido usar este servicio.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            2. Descripción del servicio
          </Typography>
          <Typography variant="body1" paragraph>
            MekaSys es una plataforma de gestión integral para talleres mecánicos que ofrece diversos servicios según el plan contratado. Nos reservamos el derecho de modificar, suspender o discontinuar cualquier aspecto del servicio en cualquier momento.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            3. Uso de la información
          </Typography>
          <Typography variant="body1" paragraph>
            Al utilizar nuestros servicios, usted acepta que sus datos podrían ser usados para fines de marketing y para mejorar la experiencia del usuario. Esto puede incluir el envío de comunicaciones promocionales, análisis de uso y personalización del servicio.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            4. Planes y pagos
          </Typography>
          <Typography variant="body1" paragraph>
            Los precios de nuestros servicios se expresan en Pesos Chilenos (CLP). El pago se procesa al momento de la suscripción y se renueva automáticamente según el ciclo elegido (mensual o anual) hasta que el usuario decida cancelar su suscripción.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            5. Responsabilidades del usuario
          </Typography>
          <Typography variant="body1" paragraph>
            El usuario es responsable de mantener la confidencialidad de su cuenta y contraseña, así como de la exactitud de los datos ingresados en el sistema. MekaSys no se responsabiliza por la pérdida de información debido a un uso inadecuado de la plataforma.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            6. Modificaciones a los términos
          </Typography>
          <Typography variant="body1" paragraph>
            MekaSys puede revisar estos términos de servicio en cualquier momento sin previo aviso. Al utilizar este sitio, usted acepta estar sujeto a la versión actual de estos términos y condiciones.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            7. Ley aplicable
          </Typography>
          <Typography variant="body1" paragraph>
            Estos términos y condiciones se regirán e interpretarán de acuerdo con las leyes de Chile, sin tener en cuenta sus disposiciones sobre conflictos de leyes.
          </Typography>

          <Typography variant="body1" paragraph sx={{ mt: 6 }}>
            Para cualquier consulta relacionada con estos términos y condiciones, puede contactarnos a través de: contacto@mekasys.info
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TermsPage; 